'use client';

import { useEffect, useState } from 'react';

// 在ssr控制台会报错，但是不影响使用
// import('wc-waterfall');

interface IWaterfallProps {
  className?: string;
  cols?: number;
  gap?: number | [number, number] | string;
  children: React.ReactNode;
  showTour?: boolean;
}

function Waterfall(props: IWaterfallProps) {
  const { className, cols = 2, gap = 20, children, showTour } = props;
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    import('wc-waterfall').then(() => {
      setIsClient(true);
    });
  }, []);

  return isClient ? (
    <div className={className}>
      <wc-waterfall
        cols={cols}
        data-type={showTour ? 'tour' : ''}
        gap={gap}
        id={showTour ? 'tour' : ''}
      >
        {children}
      </wc-waterfall>
    </div>
  ) : null;
}

export default Waterfall;
